// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__1W8J2","btnRed":"styles_btnRed__3ZeHQ","buttons":"styles_buttons__yos9B"};